module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "epi"
  }, [_c('a', {
    attrs: {
      "id": "page_xix"
    }
  }), _c('a', {
    attrs: {
      "id": "page_xx"
    }
  }), _c('a', {
    attrs: {
      "id": "page_1"
    }
  }), _c('i', [_vm._v("Because the world is round, it turns me on."), _c('br'), _vm._v("– from “Because” by the Beatles")])]), _vm._v(" "), _c('p', {
    staticClass: "h2",
    attrs: {
      "id": "ch1"
    }
  }, [_vm._v("Chapter One")]), _vm._v(" "), _c('p', {
    staticClass: "h2a"
  }, [_vm._v("Beginning Point")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("T")]), _vm._v("he idea for this book came about in 2003. At that time, Dick Morley was hosting his annual “Geek Pride Day.” This was a highlight of June, when he invited 60 or so intellectual types and business leaders for a day of discussion and idea exchanges. The event was hosted on his farm in Mason, New Hampshire. The food was always good, and the presentations were both interesting and informative. While most people came from the local area, some came from as far away as Pennsylvania for this event.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("At that time, I conceived of the idea of writing a book that talked about fluid flow, instrumentation and measurement. Measuring fluid flow is part of a broader range of tasks involving sensing and measurement. I figured that with my background in philosophy and flow, and Dick’s knowledge of physics, we could analyze these topics from different perspectives. After discussing this idea back and forth for quite a few years, we approached ISA with the idea of publishing the book. This is the book that resulted from our efforts.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("We selected the title "), _c('i', [_vm._v("The Tao of Measurement: A Philosophical View of Flow and Sensors")]), _vm._v(" because “Tao” conveys the idea of “underlying principle” or “path.” Although this book is not based on Taoism or the teachings of Lao-Tzu, it does attempt to reach beyond a purely scientific discussion of the topic in a meaningful and useful way.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("The structure of this book is as follows: "), _c('a', {
    attrs: {
      "href": "#/xhtml/Chapter01"
    }
  }, [_vm._v("Chapter 1")]), _vm._v(" - Beginning Point, followed by "), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 2")]), _vm._v(" - Temperature; "), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 3")]), _vm._v(" - Pressure; "), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4")]), _vm._v(" - Flow; "), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5")]), _vm._v(" - Time; "), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6")]), _vm._v(" - Length; "), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7")]), _vm._v(" – Area; and "), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8")]), _vm._v(" - Theory of Measurement. Dick Morley shares his perspective at the end of every chapter, including this one. The book concludes with Chapter 9, written by Dick.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('a', {
    attrs: {
      "id": "page_2"
    }
  }), _vm._v("This chapter is written more like an executive summary than an introduction. As you read through this chapter, you will gain an insight into the main points made in the book. You can then go to the chapter or chapters that interest you most. For example, if your area of interest is fluid flow, you may want to start with "), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Four")]), _vm._v(". If you are fascinated by time, go to "), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Five")]), _vm._v(". Each chapter is designed as a standalone treatment of the topic of that chapter. The only exception is "), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Eight")]), _vm._v(", which attempts to bring the areas of sensing and measuring together into a broader theory. Of course, we want you to read the entire book, but that’s up to you.")]), _vm._v(" "), _c('p', {
    staticClass: "h3",
    attrs: {
      "id": "sec1"
    }
  }, [_vm._v("Scope")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("This book covers both sensing and measuring. These are broad topics, but we have selected six subjects within those topics that are of special interest. First, we focus on sensing and then measuring these three parameters:")]), _vm._v(" "), _c('div', {
    staticClass: "top"
  }, [_c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("•"), _c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Temperature")])]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("•"), _c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Pressure")])]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("•"), _c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Flow")])])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("The discussion of sensing temperature, pressure and flow centers mainly on the different types of sensors that are used to sense these parameters. We then talk about how they are measured. There are a number of different technologies involved in sensing and measuring temperature, pressure and flow, and they are discussed in "), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapters 2")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")]), _vm._v(" and "), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("In measuring, we have chosen three parameters that are especially interesting and important:")]), _vm._v(" "), _c('div', {
    staticClass: "top"
  }, [_c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("•"), _c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Time")])]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("•"), _c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Length")])]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("•"), _c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Area")])])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapters 5")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")]), _vm._v(" and "), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")]), _vm._v(" center on the units used to measure these parameters. The structure of each of these chapters is similar. The first part of each chapter explores the historical origins of many of the units that we still commonly use to measure time, length and area. The origins of the terms and practices in use today go back over two "), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }), _vm._v("thousand years, to the Greeks and Romans in some cases. The second part of each of these three chapters describes the generally accepted methods for measuring the parameter in question. The last part of each chapter proposes a new perspective that hopefully avoids some of the pitfalls in the way measurement is done today. These new ideas include flowtime, Wide Line Geometry and Circular Geometry. The last section of each chapter includes a list of the units of measurement that are associated with the subject of the chapter.")]), _vm._v(" "), _c('p', {
    staticClass: "h3",
    attrs: {
      "id": "sec2"
    }
  }, [_vm._v("Chapter Two: Temperature")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Two")]), _vm._v(" begins by tracing the origins of the thermometer. Galileo is credited with inventing the first thermometer in the 1590s. It was an air thermometer made of a glass bulb with a long tube attached. While Galileo called it a "), _c('i', [_vm._v("thermoscope")]), _vm._v(", it worked enough like a thermometer to earn him the title of the inventor of the thermometer.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("There are three main temperature scales that are commonly used today:")]), _vm._v(" "), _c('div', {
    staticClass: "top"
  }, [_c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("•"), _c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Fahrenheit")])]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("•"), _c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Celsius")])]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("•"), _c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Kelvin")])])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("This chapter compares the origins of these scales and shows how they compare to each other. Another important scale is the Rankine scale, which is mainly used for specialized engineering applications.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Most of the rest of "), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Two")]), _vm._v(" is devoted to a discussion of the following five types of temperature sensors:")]), _vm._v(" "), _c('div', {
    staticClass: "top"
  }, [_c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("•"), _c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Thermocouples")])]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("•"), _c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Resistance Temperature Detectors (RTDs)")])]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("•"), _c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Thermistors")])]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("•"), _c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Infrared Thermometers")])]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("•"), _c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Fiber Optic Sensors")])])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("The first three types on this list are contact temperature sensors, while infrared and fiber optic are non-contact types. Infrared thermometers sense the temperature and also display it, so they are also measuring devices.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _vm._v("There are a number of different types of "), _c('i', [_vm._v("thermocouples")]), _vm._v(" that are distinguished according to the type of metals making them up. Each one is designated with an alphabetical letter, and they are designed for different temperature ranges. The two main types of RTDs are wirewound and thin film. "), _c('i', [_vm._v("Thermistors")]), _vm._v(" are less robust than RTDs and have a more narrow temperature sensing range, but are more sensitive than RTDs within that range. They are widely used for food applications. "), _c('i', [_vm._v("Infrared thermometers")]), _vm._v(" are used to measure temperature at a distance. Many of them are used in a “point and shoot” method of measuring, where the temperature is read off the material that the infrared beam is aimed at. "), _c('i', [_vm._v("Fiber optic")]), _vm._v(" sensors use optical fibers in making temperature measurements.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("This chapter concludes with a discussion of the relative advantages and disadvantages of the different types of temperature sensors. For example, thermocouples can be used at higher temperatures than RTDs and respond more quickly, but RTDs are more stable than thermocouples and are more accurate than thermocouples within their more limited temperature range.")]), _vm._v(" "), _c('p', {
    staticClass: "h3",
    attrs: {
      "id": "sec3"
    }
  }, [_vm._v("Chapter Three: Pressure")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("This chapter begins by looking at different definitions of pressure. Most of the chapter is then devoted to pressure transmitters, especially differential pressure transmitters, which play an important role in flowrate measurement. Transmitters accept input from a sensor, amplify it, and convert its value into a signal that can be transmitted to a recording or controlling device.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Differential pressure (DP) transmitters are one of four types of pressure transmitters. These four types are as follows:")]), _vm._v(" "), _c('div', {
    staticClass: "top"
  }, [_c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("•"), _c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Multivariable")])]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("•"), _c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Differential pressure")])]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("•"), _c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Gage")])]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("•"), _c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Absolute")])])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("The early part of the chapter traces the history of differential pressure measurement. Bernoulli developed his famous equation for flowrate calculation in 1738. Differential pressure transmitters rely on a constriction in the flowstream to create a "), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _vm._v("difference between upstream and downstream pressure. Differential pressure transmitters then use this difference in pressure as a variable in Bernoulli’s equation to calculate the rate of fluid flow through a pipe.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("The constriction is created by what is called a "), _c('i', [_vm._v("primary element")]), _vm._v(". The most widely used type of primary element is the orifice plate. The first commercial orifice plate was introduced in 1909. Since that time a great deal of work has been done by the American Gas Association (AGA) and the American Society of Mechanical Engineers (ASME) in studying DP flowmeters and how they perform under various conditions. Both the AGA and ASME have issued standards for the use of DP flowmeters as a result of their research.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Three")]), _vm._v(" also describes the following three pressure sensor technologies:")]), _vm._v(" "), _c('div', {
    staticClass: "top"
  }, [_c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("•"), _c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Piezoresistive")])]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("•"), _c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Strain gage")])]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("•"), _c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Capacitive")])])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("These three technologies are used by differential pressure sensors to detect upstream and downstream pressure in differential pressure transmitters.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Differential pressure sensors are an essential component of DP flow measurement, but primary elements are equally important, since they create the difference in pressure in the flowstream that makes DP flow measurement possible. The main kinds of primary elements are:")]), _vm._v(" "), _c('div', {
    staticClass: "top"
  }, [_c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("•"), _c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Orifice plates")])]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("•"), _c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Venturi tubes")])]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("•"), _c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Pitot tubes")])]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("•"), _c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Flow nozzles")])]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("•"), _c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Wedge elements")])])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('i', [_vm._v("Orifice plates")]), _vm._v(" consist of a round, usually metal plate with an opening (orifice) in it to enable fluid to pass through. They are used to measure the flowrate of liquid, steam and gas flowstreams. "), _c('i', [_vm._v("Venturi tubes")]), _vm._v(" are especially useful for fluids with suspended solids because of their wide openings. "), _c('i', [_vm._v("Flow nozzles")]), _vm._v(" are especially suited to measuring high-speed flows, and can handle fluids containing particles. "), _c('i', [_vm._v("Pitot tubes")]), _vm._v(" are widely used for "), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }), _vm._v("measuring air flow. Averaging Pitot tubes contain more than one measuring port and provide higher accuracy than single port Pitot tubes. They are also used to measure fluid flow in large pipes. "), _c('i', [_vm._v("Wedge elements")]), _vm._v(" are manufactured by only a few companies. They are designed to handle fluids with a high solids content.")]), _vm._v(" "), _c('p', {
    staticClass: "h3",
    attrs: {
      "id": "sec4"
    }
  }, [_vm._v("Chapter Four: Flow")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Four")]), _vm._v(" is devoted to discussing the different types of flowmeters used to measure flowrate, which is often shortened to “flow” when there is little chance of misunderstanding. It begins by distinguishing between new-technology flowmeters and traditional technology flowmeters. New-technology flowmeters were introduced after 1950 and are more the object of product development today than traditional technology flowmeters. Traditional technology flowmeters were introduced before 1950 and their performance is typically not at the same level as that of new-technology flowmeters.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("The following is a list of the different types of flowmeters:")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext5",
    attrs: {
      "id": "subsec1"
    }
  }, [_c('b', [_vm._v("New-Technology Flowmeters")])]), _vm._v(" "), _c('div', {
    staticClass: "top"
  }, [_c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("•"), _c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Coriolis")])]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("•"), _c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Magnetic")])]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("•"), _c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Ultrasonic")])]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("•"), _c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Vortex")])]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("•"), _c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Thermal")])])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext",
    attrs: {
      "id": "subsec2"
    }
  }, [_c('b', [_vm._v("Traditional Technology Flowmeters")])]), _vm._v(" "), _c('div', {
    staticClass: "topt"
  }, [_c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("•"), _c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Differential Pressure")])]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("•"), _c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Positive Displacement")])]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("•"), _c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Turbine")])]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("•"), _c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Open Channel")])]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("•"), _c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Variable Area")])])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext1"
  }, [_vm._v("Each section discussing these flowmeters includes:")]), _vm._v(" "), _c('div', {
    staticClass: "top"
  }, [_c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("•"), _c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Principle of Operation")])]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _vm._v("•"), _c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Paradigm Case Application")])]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("•"), _c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Applications")])])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("The Paradigm Case Application section includes a specification of the conditions that are ideal for the best operation of this type of flowmeter. For example, the paradigm case application for turbine flowmeters is for measuring the flowrate of "), _c('b', [_vm._v("clean gases or clean low-viscosity liquids flowing at medium to high speeds")]), _vm._v(". Some sections also discuss the different types of the meter in question. For example, there are eight main types of turbine flowmeters.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("The chapter concludes with a discussion of the emerging technologies of sonar and optical flowmeters. These two technologies were introduced after the year 2000 and are currently manufactured by only a handful of suppliers. "), _c('i', [_vm._v("Sonar")]), _vm._v(" flowmeters are used in water & wastewater and pulp & paper applications, among others. One major use for "), _c('i', [_vm._v("optical")]), _vm._v(" flowmeters is emissions monitoring.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Another technology not discussed in "), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Four")]), _vm._v(" that can also be considered an emerging technology is multiphase flow measurement. Multiphase flowmeters measure the mixture of oil, gas and water that comes out of an oil well. Research on these began in Norway shortly after 1980. The motivation for the research was the declining performance of the North Sea oil fields. Multiphase flowmeters perform a valuable measurement, but they are very expensive. The technology is still in its early stages, and accuracy is a major concern for these flowmeters.")]), _vm._v(" "), _c('p', {
    staticClass: "h3",
    attrs: {
      "id": "sec5"
    }
  }, [_vm._v("Chapter Five: Time")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("Time and time-keeping is a topic that almost everyone is intimately familiar with. Our society today is increasingly “schedule-driven.” Of course, in order to have social events such as school classes, football games and business hours of operation, it is necessary to have a common method of measuring time that is available to all and is generally agreed upon. For the familiar daily scheduling of our activities, time-keeping today is provided by clocks and watches.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("While there is fairly wide consistency in the units of time used for clocks and watches, beyond that things are not as simple as they may seem. There are 24 different time zones around the world, most of them one hour apart. Because of the earth’s "), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _vm._v("rotation, the sun rises and sets at different times in different places. Time zones take this into account so that people in different parts of the world can sleep through the night and enjoy the sunrise, if they are up early enough. It also better serves the needs of business and industry. Anyone who does business in other countries, or indeed between the far ends of the larger countries, needs to take time differences into account. For example, when it is 11:00 am on the East Coast of the United States, it is already 5:00 pm in much of Europe, so most business-oriented phone calls to Europe from the United States (for example) should be made before then.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Our bodies become adjusted to the time zone we are in. As anyone who has traveled through three or more time zones by airplane knows, making the adjustment to a new time zone can be difficult. If you fly from New York to Los Angeles, for example, the clock may say 8:00 pm there but for you it is 11:00 pm. I was able to traverse all 24 time zones in one trip to Australia by flying from Boston to New York and then east to Dubai to Perth, Australia. I then continued east to Sydney, Australia, to Dallas, and back to Boston. (This took considerably less than the 80 days it took in Jules Verne’s book, “Around the World in 80 Days.”) Modern day transportation has made it possible to travel to even remote parts of the globe in considerably less than 24 hours.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Five")]), _vm._v(" describes early methods of time-keeping, which mainly related to agricultural needs. Much of the life of the ancient Egyptians centered around the Nile River, which flooded from the end of June until October. Crops were planted during this time, and grew until late February. Crops were harvested from then until the end of June. The Egyptians measured the flood level of the Nile with a stick, which became the basis for a “Nile Year.” They developed a workable 12 month calendar that allotted 30 days to each month and added five days at the end of the year.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("The Romans used sundials and water clocks to measure time. In early Greece, water clocks were used to measure the length of time allowed for pleading in court. Orators would not infrequently ask for the water flow to be stopped to allow them more time to talk. In the 8th century A.D., the hourglass was invented. Hourglasses were used to measure specific periods of time, and they had the advantage that they worked both day and night. By the 15th century they were being used in England to measure the length of sermons.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _vm._v("Our division of the day into two 12 hour periods seems to go back to early sundials, many of which were divided into 12 equal parts. Our division of hours into 60 minutes and of minutes into 60 seconds is rooted in the Babylonian number system, which was based on the number 60.")]), _vm._v(" "), _c('p', {
    staticClass: "h4",
    attrs: {
      "id": "subsec3"
    }
  }, [_vm._v("The Invention of Mechanical Clocks")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("Christiaan Huygens is credited with inventing the pendulum clock in 1656. By the mid-1600s, pendulum clock movements were in common use, making it possible to add a minute hand and a second hand to the early mechanical clocks.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("In the 18th century, clocks were still expensive. Watches began to be made in the late 1600s, and by the early 1800s, clockmakers had begun to work on methods of mass production, which made both clocks and watches accessible to many more people. In the late 1920s an engineer at Bell Laboratories discovered that using a quartz crystal greatly increased the accuracy of clocks and watches. This invention was followed by the development of atomic clocks, which provided even greater accuracy.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("In the 1960s, digital clocks began to be used, and digital watches were first available in the early 1970s.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("There is much to be said for the accuracy of today’s clocks and watches. Clocks are everywhere, including on televisions and radios, and it is difficult not to be aware of the time. Radio and television programming is scheduled to begin and end at precise times, as are most sporting events, public meetings and workdays. Planes and trains are scheduled to depart to the exact minute, although they are notorious for sometimes “running late.” All this precision and accuracy have facilitated the operation of societies composed of millions of people, and in some cases, this extensive scheduling is required for safety reasons. If pilots were to fly planes without adhering to schedules, there would soon be chaos in the skies.")]), _vm._v(" "), _c('p', {
    staticClass: "h4",
    attrs: {
      "id": "subsec4"
    }
  }, [_vm._v("Clock Time and Biological Rhythms")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("Having granted that there are many advantages to “living by the clock,” there is something vaguely disquieting about having one’s life so completely governed by what is a mechanical and somewhat arbitrary division of time into 24 hours, 60 minutes and "), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _vm._v("60 seconds. For many people, clocks dictate when we rise in the morning, when we have lunch, when we have dinner and when we go to bed. However, human beings are biological beings, not mechanical devices, and our needs do not necessarily conform to the requirements of a 1440 minute day. The units of time that we are governed by are based on our ability to divide time into many tiny equal segments; they are not designed to coincide with the flow of our biological rhythms.")]), _vm._v(" "), _c('p', {
    staticClass: "h4",
    attrs: {
      "id": "subsec5"
    }
  }, [_vm._v("Decimal Time and Flowtime")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Five")]), _vm._v(" also discusses the history and merits of decimal time and “flowtime.” There are different forms of decimal time. Some divide the day into 10 hours rather than 24 hours. The hour is often divided into 100 minutes rather than 60, and minutes are typically 100 seconds long. The French instituted such a form of decimal time in 1793. However, people were unable to make the adjustment to the change in time and it lasted only 17 months.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Flowtime is a new form of time that is proposed in "), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Five")]), _vm._v(". Flowtime keeps the 24 hour clock, but allocates 100 minutes to an hour and 100 seconds to a minute. This system of time would be easier to adjust to than was the French decimal time system with 10 hours per day. In addition, with the advent of digital clocks and watches, displaying flowtime would not be as difficult as it is on a typical analog clock.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("The chief advantage of flowtime is that it divides time into smaller units. The National Basketball Association already uses a form of decimal time for the last few minutes of most games. Instead of having the clock simply tick off the remaining seconds, each second is divided into tenths of a second, so instead of showing 2 seconds left on the clock, a play might occur with 1.3 seconds left. Since in some cases the outcome of a game can depend on exactly when a shot was made, this allows both players and referees to understand exactly how much time is left in the game and at exactly what time certain plays were made. Time is also divided into tenths or hundredths of a second at certain Olympic events such as swimming and skiing.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Flowtime also has applications for daily life. It is sometimes said that work is often completed in the time allowed, whether that much time is required or not, so someone who is allowed a half-day to complete a task may take the entire half-day, even if it "), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _vm._v("could be completed in 2½ hours. Somehow the time used to finish the work expands to meet the time allotted for the work.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Flowtime provides more units of time within which to complete a task. While these units of time are smaller, they make it easier to divide a task into smaller parts, so if one is allotted a half-day to complete a task, this translates into 4 hours, as in traditional time, but these 4 hours translate into 400 flowtime minutes instead of the traditional 240. Because there are more units of time to work with, it is easier then to break the job into smaller segments and potentially complete it sooner, rather than simply thinking of it as a half-day job. Flowtime facilitates the setting of smaller subtasks within a larger task, which often helps to complete it more quickly.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Any broadscale transition to flowtime will be difficult until flowtime clocks are available. However, as just noted, a form of flowtime is already used in some sporting events and it is possible to apply flowtime mentally by thinking of hours as having 100 minutes and minutes as having 100 seconds. Digital clocks should make it easier to display flowtime than with analog clocks. Digital clocks display the minutes and seconds, while analog clocks only approximate them. "), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Five")]), _vm._v(" includes a table for converting traditional time to flowtime.")]), _vm._v(" "), _c('p', {
    staticClass: "h3",
    attrs: {
      "id": "sec6"
    }
  }, [_vm._v("Chapter Six: Length")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("Length may seem like an unusual choice of topic for this book, but length is one of the most fundamental quantities in our lives. In fact, length is almost as pervasive as time in our daily and business lives. Surrounding and related to length is a cluster of vital units of measurement that we encounter daily. These include distance, miles, inches, meters, points, lines and continuity. The distance between two points is measured in units of length, and it is often important to know how far it is to some location, or how high or wide an object is. These parameters are all interconnected, and discussing length requires a discussion of many of these other parameters as well.")]), _vm._v(" "), _c('p', {
    staticClass: "h4",
    attrs: {
      "id": "subsec6"
    }
  }, [_vm._v("Arriving at a Unit of Measurement")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Six")]), _vm._v(" begins with a look at the historical origin of some of the terms we use today to designate units of length. The idea of a foot as consisting of 12 inches goes back "), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }), _vm._v("to Roman times. Around the 12th century, the idea arose of defining a foot as 1/3 of a yard. King Henry I of England decreed the yard to be the distance from his nose to the tip of his outstretched thumb. Later on, in the 1740s, the British government attempted to establish the length of a yard through the construction of a brass bar of the required length. In 1834, the two existing standard yard bars were destroyed by fire. The effort was renewed and continued until 1855, when a bar made with advanced thermometers to account for thermal expansion was declared the legal standard.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("In 1866, the use of the metric system became permissible in the United States, due to an Act of Congress. After this time, the focus turned to defining the length of a standard meter, with the length of a yard being defined in terms of the length of a meter. Eventually, the idea of using a standard bar to define the length of a meter was abandoned, and a meter’s length was defined in terms of the path length traveled by light in a vacuum during a time interval that is a tiny fraction of a second.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Much of the discussion in "), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Six")]), _vm._v(" relates to analyzing the relationship between a point and a line. A line is typically drawn between two points, and the distance between two points is often represented as a line. The number line is similar, but it mainly figures in discussions about geometry and the existence of points in the line or on the line. In Euclidean geometry, the number line is often conceived of as a straight line consisting of infinitely many points stretched out to infinity in both directions. It is always possible to put another point between any two points, so there are infinitely many points.")]), _vm._v(" "), _c('p', {
    staticClass: "h4",
    attrs: {
      "id": "subsec7"
    }
  }, [_vm._v("Oh Line, Where Is Thy Point?")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("A common mathematical conception is that the number line is made up of points, and that another point can lie between any two points. Each point is conceived of as having no dimension or area, so there can be infinitely many points in the number line. The main problem with this idea is that if lines are made up of points with no area, it doesn’t matter how many of them you put side by side – the line will still not have area or dimension. Mathematicians try to fix this problem by bringing in infinity, and saying that infinitely many points make up the number line, but zero times "), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }), _vm._v("any number is zero, and zero times infinity is still zero. Infinity thus becomes a kind of metaphysical glue that salvages one questionable assumption with another, equally questionable assumption.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("A more logical conception is that points lie "), _c('i', [_vm._v("on")]), _vm._v(" the line and are not "), _c('i', [_vm._v("in")]), _vm._v(" the line. If we say this, then even if points have no area, we can still account for the extension of the line by saying it is an unbroken continuum. We can always put another point between two arealess points since there will always be space for still another point that takes up no area.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("There are other problems with saying that points have no area, however, for to do so is to invite Zeno’s Paradox, which is discussed in detail in "), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6")]), _vm._v(". Zeno’s Paradox gets its power from conceiving of a person as being at rest at an arealess point. If we conceive of a person as being located at an arealess point, then when he goes halfway, he will be once again at an arealess point. If we continue to multiply by ½, he will in theory never reach his destination since as long as points take up no area; this is an infinite process. Of course, this process of reaching a destination by going halfway each time requires the traveler to stop at each arealess point, which is not what happens with continuous motion.")]), _vm._v(" "), _c('p', {
    staticClass: "h4",
    attrs: {
      "id": "subsec8"
    }
  }, [_vm._v("Wide Line Geometry")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("Another approach to this topic is to follow Aristotle’s definition of a line as a moving point. If we also say that points have area, we can block Zeno’s Paradox. This is because there are no longer infinitely many points on the number line. Instead, the number of points on the line is subject to stipulation for a given measurement. If the measurement is made as 1/1000 of an inch, then there are 1,000 points on one inch of the line. If the measurement is made as one-millionth of an inch, then there are one million points on the line, however small a millionth of an inch is. But specifying the location of any object with reference to the points on the line requires that the location be at one of those points. Fractions of a point or partial points are not allowed. This blocks Zeno’s Paradox since at some point it will be necessary to specify a location that is a fractional point on the line. This is not allowed because the only legitimate locations "), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }), _vm._v("on the line have been specified when the number of points on the line has been specified. In order to capture the desired location, it is necessary to specify a number line with greater precision; that is, with a larger number of smaller points on the line.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("If we follow Aristotle’s definition that a line is the path of a moving point, and that a point has area, then a line has a width equal to the diameter of the point used to create it. This is not to say that mathematics is about actual drawn lines rather than the idealized lines they represent, but saying that lines have width coincides much more closely with the way we think of lines in the real world. The chalk lines that mark the edge of a baseball field and the 10-yard markers that divide the field in American football all have width; they do not stand for Euclid’s “breadthless lengths.” Another example is the solid and broken lines that divide a highway into two sides.")]), _vm._v(" "), _c('p', {
    staticClass: "h4",
    attrs: {
      "id": "subsec9"
    }
  }, [_vm._v("Defining Continuity")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("If we consider a number line to be continuous, and that discrete points with specifiable area lie on the line, how do we define the line itself? A line is a continuous entity. It is hard to define continuity without using negative terms like “unbroken,” “uninterrupted” and “nonstop.” These in effect define continuity in terms of what it is not. A continuous noise is uninterrupted; a continuous game is one that goes on without stopping, and a continuous line is one that is unbroken. This applies to a line of any length; lines are of finite length and are also referred to as line segments. One way to define a line is “an unbroken extension that has the shape of the path that a point with a diameter of the width of the line would make if it were moved from one end of the unbroken extension to the other.”")]), _vm._v(" "), _c('p', {
    staticClass: "h4",
    attrs: {
      "id": "subsec10"
    }
  }, [_vm._v("Measuring Locations when Measuring Distance")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("The idea that points have area is given additional support by the way we measure distance. If we measure the distance from the Eiffel Tower in Paris to the Van Gogh Museum in Amsterdam, we might consider any location at the Eiffel Tower as a starting point. It could be in front of the Eiffel Tower, to the side, or even underneath the Tower. Likewise, arriving at the Van Gogh Museum could be arriving at the parking "), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }), _vm._v("lot, simply getting onto the grounds, or parking on the road by the side of the museum. Here we treat the beginning point and the ending point as a point with area that is loosely defined by its proximity to the object in question. We don’t treat these two points as being dimensionless points.")]), _vm._v(" "), _c('p', {
    staticClass: "h4",
    attrs: {
      "id": "subsec11"
    }
  }, [_vm._v("American vs. Metric Standards")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("One of the remaining challenges in measuring length and distance is the difference between different measuring systems. The most obvious one is the difference between the American convention of using inches, feet, yards and miles and the metric system that uses millimeters, meters and kilometers. While most of the world uses the metric system, the United States has been slow to adopt it. Still, it is gaining a hold in the United States. One problem with this partial adoption of the metric system is that there is not always an exact conversion from one to the other, so the conversions that are used are often approximations. The same issue arises for measuring circular area in terms of squares, as is discussed in "), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Seven")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "h3",
    attrs: {
      "id": "sec7"
    }
  }, [_vm._v("Chapter Seven: Area")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Seven")]), _vm._v(" talks about area as measured in circles and squares. Traditional and Euclidean geometry uses the formula π × r"), _c('sup', [_vm._v("2")]), _vm._v(" for the area of a circle, in which r is the circle’s radius. Interestingly, though, r"), _c('sup', [_vm._v("2")]), _vm._v(" is the area of a square that has four sides, each with a length r. So if r = 2, then the area of a square with sides of this length is 4 square inches, and the formula is telling us that π × 4 square inch squares fit inside the circle. While this is an accepted mathematical truth, it seems counterintuitive in light of the saying “You can’t put a square peg inside a round hole.”")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("In "), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Seven")]), _vm._v(", I propose using a “round inch” instead of a square inch as a unit of measure for circular area. One round inch is equal to π/4 from a Euclidean point of view. The advantage of this is that it is then possible to give rational values for the area of a circle without relying on the irrational number π. The formula for the area of a circle in round inches becomes 4 × r"), _c('sup', [_vm._v("2")]), _vm._v(", where r is the radius of the circle. I propose to call this Circular Geometry.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }), _vm._v("If we add Wide Line Geometry to Circular Geometry, it is possible to give rational values for the areas of three-dimensional structures such as pipes. Pipes can be treated as having a “wide line” boundary. The inside diameter can be used for calculating flowrate, while the outside diameter is used to give the size of the pipe including the width of the pipe wall. This idea can be applied to the flow equation:")]), _vm._v(" "), _c('p', {
    staticClass: "bodytexti"
  }, [_vm._v("Q = A × v")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Here Q is equal to flowrate, A is the area of the pipe in round inches using the inside diameter (ID), and v is flow velocity. This eliminates π, a source of uncertainty and irrationality in the flow equation.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Why is π necessary to begin with? The necessity for π stems from the fact that square area and circular area cannot both be measured using the same unit of measurement. Just as circular area has irrational values when using square area as a unit of measurement, so square and rectangular area will have irrational values when using round inches as a unit of measurement. We either need to have two separate geometries, or be content with irrational numbers such as π in giving circular area. I would at least like to explore the benefits of using Circular Geometry to analyze circular area. I believe it also has important applications in flow measurement.")]), _vm._v(" "), _c('p', {
    staticClass: "h3",
    attrs: {
      "id": "sec8"
    }
  }, [_vm._v("Chapter Eight: Sensors and Measurement")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Eight")]), _vm._v(" attempts to bring the worlds of sensors and measurement together. It begins with a definition of what a sensor is: A sensor senses changes in a physical quality or property, and responds to them in a predictable say. This representation is a reading of the quality or quantity of the physical parameter being sensed. The response must be predictable, or statable according to some rule, to ensure that the sensor is accurate. This chapter discusses mechanical, electronic and biological sensors.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("The signals from sensors are often weak. This is why a converter, transducer or transmitter is needed. Such a device accepts input from the sensor, typically amplifies it, and changes it into a representation of the quality or quantity of the variable that is being sensed. If the transducer or transmitter is electronic, this representation will be in electronic form. Transmitters are so-called because they transmit a signal. Transmitters "), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }), _vm._v("take the electronic representation of the sensor’s input and convert it into a signal that can be transmitted to a recording or controlling device. Typical signals include 0–5 millivolts, 4–20 milliamps and various types of digital signals.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("This definition of a sensor also helps explain what goes on with the biological sensors that human beings have. Our eyes, for example, accept input in the form of light and convert this in a predictable way in the visual cortex, which is the part of the brain that processes input from the eyes. The image formed in the visual cortex is then transmitted to and processed by the part of the brain associated with seeing and consciousness. The brain acts like a converter or transducer and turns the image formed in the visual cortex into an image that we see through a process of interpretation.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("This analysis shows a link between the physical world and our consciousness. When our brains convert visual images into an image that we see, they do so by creating neural patterns that are associated with our conscious perception. This shows how the mind-body problem that Descartes set up can be solved. Descartes defined mind (unextended) and body (extended) as opposites. But when we examine how the brain works, which is somewhat like an electronic transmitter, we can see that certain neural patterns are associated with specific conscious experiences. Mind and body are not opposites, but just complex aspects of each other.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("This chapter also defines what a measuring device is. A measuring device makes use of a standard unit of measurement. This unit of measurement is used to determine a quantity that formulates how much of that unit something has. This unit of measurement could be in the form of a scale, like on a yardstick, or it could take the form of a calculated unit like gallons per minute (gpm) as in a flowmeter.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Probably the biggest difference between sensing and measuring is that there is some type of interaction between a sensor and what is sensed – the sensor responds in a predictable way to the quantity or quality that is being sensed. A measuring device, in contrast, does not respond in this way to what is being measured. It simply determines how much size, length or other quantity of a unit of measurement something has. This is done by performing some type of comparison between the unit of measurement and the object being measured.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }), _vm._v("A meter is an instrument designed to measure the size, length or quantity of something. For example, a flowmeter measures the amount of fluid passing through a closed pipe or an open channel.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("The chapter closes with a list of different types of flowmeters used in scientific and process environments.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8418ec00","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Chapter01.vue
// module id = 75
// module chunks = 0